import React, { forwardRef } from 'react'
import { Dialog, DialogContent, Slide } from '@mui/material'
import { motion } from 'framer-motion'
import { RetirementSolver } from 'components/RetirementSolver'

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" timeout={300} ref={ref} {...props} />
})

export default function RetirementSolverModal({
  parcoReadinessScore4Percent,
  adjustedNetTakeHomeDifferencePARCOGap,
  valueOfInvestableAssets,
  parcoAnnuityRecommendation,
  neededForRetirementFull,
  neededForRetirementTrimmed,
  neededForRetirementParco,
  onClose,
}) {
  return (
    <Dialog
      fullScreen
      open
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      PaperProps={{
        sx: {
          overflow: 'auto',
        },
      }}
    >
      <DialogContent sx={{ overflow: 'visible' }}>
        <motion.div
          key="scheduler"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
          <RetirementSolver
            parcoReadinessScore4Percent={parcoReadinessScore4Percent}
            adjustedNetTakeHomeDifferencePARCOGap={
              adjustedNetTakeHomeDifferencePARCOGap
            }
            valueOfInvestableAssets={valueOfInvestableAssets}
            parcoAnnuityRecommendation={parcoAnnuityRecommendation}
            neededForRetirementFull={neededForRetirementFull}
            neededForRetirementTrimmed={neededForRetirementTrimmed}
            neededForRetirementParco={neededForRetirementParco}
            closeModal={onClose}
          />
        </motion.div>
      </DialogContent>
    </Dialog>
  )
}
